import { render, staticRenderFns } from "./RegistrationRequests.vue?vue&type=template&id=7fb08821"
import script from "./RegistrationRequests.vue?vue&type=script&lang=js"
export * from "./RegistrationRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports